import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export function validatedInput(mandatory: boolean, minLength: number, maxLength: number, minValue: number, maxValue: number, regex?: string): ValidatorFn[] {
  const ret: ValidatorFn[] = [];

  if (mandatory) {
    ret.push(Validators.required);
  }

  if (mandatory && (minLength != null)) {
    ret.push(Validators.minLength(minLength));
  }

  if (maxLength != null) {
    ret.push(Validators.maxLength(maxLength));
  }

  if (minValue != null) {
    ret.push(Validators.min(minValue));
  }

  if (maxValue != null) {
    ret.push(Validators.max(maxValue));
  }

  if (regex) {
    ret.push(Validators.pattern(new RegExp(regex)));
  }

  return ret;
}

export function leapDayValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const value = control.value;
  const isEmpty = (value === null || value === undefined || value === '');
  if (isEmpty) {
    return null;
  }

  const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
  const invalidObj = { date: true };
  const parts = value.toString().split('.');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  // Unvollständige Daten nicht prüfen.
  if (day === 0 || month === 0) {
    return null;
  }

  const isValidYear = (1900 < year) && (year < 2100);
  const isValidMonth = (1 <= month) && (month <= 12);
  if (!isValidMonth || !isValidYear) {
    return invalidObj;
  }

  if (isLeapYear(year)) {
    monthLength[1] = 29;
  }

  const maxDaysInMonth = monthLength[month - 1];
  const isValidDay = (1 <= day) && (day <= maxDaysInMonth);

  return isValidDay ? null : invalidObj;
}

function isLeapYear(year: number): boolean {
  return (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0));
}

export function isRequired(formControl: AbstractControl) : boolean {
  return formControl.hasValidator(Validators.required);
}
